import { bankReconciliationDynamicMessagesEn } from "./dyanamicMessages/payments/bankReconciliationDynamicMessages";

const dynamicMessages = {
  //document review

  document_review_docclass_required: `Document {{0}} has no classification.`,
  document_review_docclass_shouldbe_oneof: `Document class should be one of '{{0}}.'`,
  document_review_is_early_duplicate: `Please review original document.`,
  document_review_not_found: `Document {{0}} not found.`,
  document_review_manual_form_header_field_value_invalid: `You have updated the '{{0}}' as '{{1}}'.This header field cannot be updated.`,
  document_review_manual_form_table_field_value_invalid: `You have updated the '{{0}}' field '{{1}}' as '{{2}}'.This table field cannot be updated.`,
  document_review_manual_form_table_row_count_mismatch: `Table '{{0}}' has mismatch row count.`,
  document_review_manual_form_table_column_not_found: `Column is missing in the '{{0}}'`,
  document_review_manual_form_table_row_structure_invalid: `Table '{{0}}' has mismatch row count.`,
  document_review_manual_form_table_not_found: `Table not found.`,
  document_review_manual_form_table_count_mismatch: `Table not found.`,

  //document configuration
  mandatory_header_field_hidden: `Cannot hide mandatory field '{{1}}' in document type '{{0}}' `,
  mandatory_table_field_hidden: `Cannot hide mandatory field '{{2}}' of table '{{1}}' in document type '{{0}}' `,
  // roles
  default_permissions_cant_be_removed:
    "Default permissions {{0}} can't be removed. ",
  only_invoice_documentclass_allowed_for_expense: `Only invoice document class is allowed for expense.`,
  atleast_one_holded_item_glaccount_required: `Atleast one holded item with GL account is required.`,
  holded_item_glaccount_required: `Holded item GL account is required for every item.`,
  holded_item_not_allowed_for_accountclass_expense: `Holded item is not allowed for account class expense.`,

  // Payments
  document_not_found: `No document found with ID(s) {{0}}`,
  duplicate_document_ids_found: `Duplicate documentId(s) found {{0}}`,
  paid_amount_exceed: `Paid amount ({{0}}) exceeds the document amount ({{1}}) for document ID {{2}}.`,
  vendor_should_same_multiple_invoice_payments_on_same_transactionid:
    "Vendor must be the same for multiple invoice payments under transaction ID {{0}}.",
  deleted_document_exists:
    "The document with ID {{0}} has been deleted and cannot be used.",
  "transactionid(s)_already_recorded":
    "The following transaction ID(s) have already been recorded: {{0}}.",
  document_review_duplicate_polygon:
    "The fields {{1}} have duplicated tagging in page {{0}}",
  accounttype_not_match_allowed_accountypes: `Account type not match with allowed account types "{{0}}"`,
  review_document_include_schedulepaymentbill: `Cannot review document. It is included in Bill Number {{0}}, which is scheduled for payment.`,
  "workflow-reason-required": `Workflow reason is required.`,

  supplier_not_found: "Supplier not found",
  supplier_is_deleted: "Supplier is deleted",
  organization_not_found: `Organization not found for the current user`,
  invalid_tax_rate_range: `Tax rate must be between 0 and 100`,
  exempt_code_required_for_zero_rate: `Exempt code is required when tax rate is 0%`,
  tax_code_required: `Tax code is required`,
  tax_type_required: `Tax type is required`,
  duplicate_tax_rate_for_exemptcode: `An active tax already exists with TaxType '{{0}}', Rate '{{2}}%', and ExemptCode '{{1}}'`,
  duplicate_tax_rate_for_code: `An active tax already exists with TaxType '{{0}}', Rate '{{2}}%', and Code '{{1}}'`,
  tax_not_found: `Tax not found`,
  either_tax_code_or_exempt_code_required: `Either tax code or exempt code is required`,
  ...bankReconciliationDynamicMessagesEn,
};
export default dynamicMessages;
